class ServicePlusButtons extends HTMLElement {
  constructor() {
    super();
    this.cartUpdateUnsubscriber = undefined;
  }

  connectedCallback() {
    this.checkCartState();
    this.cartUpdateUnsubscriber = theme.pubsub.subscribe(
      theme.pubsub.PUB_SUB_EVENTS.cartUpdate,
      this.onCartUpdate.bind(this)
    );
  }

  disconnectedCallback() {
    this.cartUpdateUnsubscriber?.();
  }

  get submitButton() {
    return this.querySelector('.product-form__submit, [type="submit"]');
  }

  onCartUpdate() {
    requestAnimationFrame(() => this.checkCartState());
  }

  hasServicePlusInCart() {
    return document.querySelector('[id^="CartDrawer-Item"][data-service-plus="true"]') !== null;
  }

  setSubmitDisabled(disabled) {
    const button = this.submitButton;
    if (!button) return;

    if (disabled) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.dataset.disabledByCart = 'true';
      button.closest('.product-form-wrapper').querySelector('#error-message-subscription_in_cart').hidden = false;
      return;
    }

    if (!button.dataset.disabledByCart) return;

    button.disabled = false;
    button.removeAttribute('aria-disabled');
    delete button.dataset.disabledByCart;
    button.closest('.product-form-wrapper').querySelector('#error-message-subscription_in_cart').hidden = true;
  }

  reveal() {
    this.style.opacity = '1';
  }

  checkCartState() {
    this.setSubmitDisabled(this.hasServicePlusInCart());
    this.reveal();
  }
}

customElements.define('service-plus-buttons', ServicePlusButtons);
